import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './tolls.scss';
import get from 'lodash/get';
import { ExpandFormRow, FormRow, Tree, Input, Columns, Tooltip } from '@here/ref-client-ui';
import { TimeDomainParser, translate } from 'utils/timeDomainParser';
import copyToClipboard from 'copy-to-clipboard';

const intersect = (a, b) => a.filter(v => new Set(b).has(v));
const timeDomainParser = new TimeDomainParser();

class Tolls extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCopied: false
    };
  }

  componentDidUpdate(prevProps) {
    const {
      setResultState,
      result: { raw },
      options: { key, formatter },
    } = this.props;

    const { result: { raw: prevRaw } } = prevProps;

    if (!!raw && !prevRaw) {
      setResultState({ [key]: {} });
      setResultState({ [`${key}-copy-${formatter}`]: {} });
    }
  }
  
  onTimeDomainClick = (v) => {
    if (v[0] === '"') {
      v = v.substr(1);
    }
    if (v[v.length-1] === '"') {
      v = v.slice(0, -1);
    }
    copyToClipboard(v);
    this.setState({showCopied: true});
  }

  onMouseOut = () => {
    this.setState({showCopied: false});
  }

  getTotalBySystemEle({totalBySystem, index, tollSystems}) {
    return totalBySystem.map(tollBySystem => {
      return (
        <FormRow key={`${tollBySystem.tollSystem}${index}`} className={'rf-section-toll-bysystem-cost'}>
          <Input
            type="text"
            label={tollSystems[tollBySystem.tollSystem].name}
            isReadonly
            value={`${tollBySystem.price.value} ${tollBySystem.price.currency}`}
          />
        </FormRow>
      );
    })
  };

  getTotalByCountryEle({totalByCountry, index}) {
    return totalByCountry.map(tollByCountry => {
      return (
        <FormRow key={`${tollByCountry.countryCode}${index}`} className={'rf-section-toll-bycountry-cost'}>
          <Input
            type="text"
            label={tollByCountry.countryCode}
            isReadonly
            value={`${tollByCountry.price.value} ${tollByCountry.price.currency}`}
          />
        </FormRow>
      );
    })
  };

  getSummaryElement({ summary, index, sectionIndex, tollSystems }) {
    const { tolls: {total, totalByCountry, totalBySystem} }= summary

    return (
      <li
        className={'rf-tollsystems rf-tollsystems__toll-summary'}
        onClick={e=> this.onClick(e, null, {tollSystems: []}, index, sectionIndex)}
        key={`tollSummary${index}`}
      >
        <div className="rf-tollsystems__inner">
          <div className="rf-tollsystems__content">Toll Summary</div>
        </div>

        { <div className="rf-tollsystems__summary-inner">
          {(total !== undefined) && (<FormRow>
            <Input
              type="text"
              label="Total"
              isReadonly
              value={`${total.value} ${total.currency}`}
            />
          </FormRow>)}
          {(totalBySystem !== undefined) && (
            <ExpandFormRow
              label="Total by Tollsystem"
              className="rf-section-toll-bysystem" 
            >
              {this.getTotalBySystemEle({totalBySystem, index, tollSystems})}
            </ExpandFormRow>
          )}
          {(totalByCountry !== undefined) && (
            <ExpandFormRow
              label="Total by Country"
              className="rf-section-toll-bycountry" 
            >
              <Columns className="rf-section-toll-bycountry__columns">
              {this.getTotalByCountryEle({totalByCountry, index})}</Columns>
            </ExpandFormRow>
          )}
        </div>}
      </li>
    );
  }

  getTollElement({ tolls, toll, index, sectionIndex, maneuvers, spans }, selected) {
    const isSelected =
      Array.isArray(selected.index) && selected.index.indexOf(index)>-1 && selected.sectionIndex === sectionIndex;
    const listItemClasses = classnames('rf-tollsystems', {
      'rf-tollsystems_selected': isSelected,
    });
    return (
      <li
        className={listItemClasses}
        onClick={e=> this.onClick(e, tolls, toll, index, sectionIndex, maneuvers, spans)}
        key={`${toll.tollSystem}${index}`}
      >
        <div className="rf-tollsystems__inner">
          <div className="rf-tollsystems__content">{toll.tollSystem}</div>
        </div>
        {isSelected && this.getDetails(toll)}
      </li>
    );
  }

  getDetails(toll) {
    if (!toll) {
      return null;
    }
    return <div className="rf-tollsystems__details">
      <FormRow>
        <Tree 
          data={toll} 
          valueRenderer={
            (raw, value, key) => {
              if ((key === 'applicableTimes') && raw !== "\"\"" ) {
                const parsedTDUnit = timeDomainParser.getString(translate(raw)).split(', \n ');
                let conditions = 0;
        
                parsedTDUnit.forEach(unit=>{
                    if (unit.indexOf('not valid') === -1) conditions++;
                })
                for (var i = 0; i < parsedTDUnit.length; i++) {
                  parsedTDUnit[i] = (conditions > 1 || parsedTDUnit[i].indexOf('not valid')===0 ? '    ' : '') + parsedTDUnit[i].charAt(0).toUpperCase() + parsedTDUnit[i].slice(1);
                }
                let parsedTDTooltip = parsedTDUnit.join('\n');

                if (conditions > 1) {
                  parsedTDTooltip = 'ANY OF\n' + parsedTDTooltip;
                }
                
                const tdTooltip = <div className="rf-form-view__tooltip">{parsedTDTooltip+`\n\n${this.state.showCopied ? 'Copied!' : 'Click to copy to Clipboard'}`}</div>
                const tdRaw = <div onClick={() => this.onTimeDomainClick(parsedTDTooltip)} onMouseOut={this.onMouseOut}>{raw}</div>
                return <Tooltip placement="right" className="toolTip-timedomain" tooltip={tdTooltip}>{tdRaw}</Tooltip>
              }
              else 
                return raw;
            }
          }
        />
      </FormRow>
    </div>;
  }

  onClick = (e, tolls, toll, index, sectionIndex, maneuvers, spans) => {
    const selection = window.getSelection();
    if (selection.toString().length !== 0 || e.target.classList.length === 0) {
      return;
    }
    const {
      setResultState,
      options: { key },
      result,
    } = this.props;
    const selected = get(result.state, key, {});
    if ((Array.isArray(selected.index) && selected.index.indexOf(index)>-1 && selected.sectionIndex === sectionIndex)) {
      setResultState({ [key]: {} });
    } else {
      let shapes = [];
      let tollSystemsIndexs = [...toll.tollSystems];
      let indexs = [index];
      if (spans) {
        tolls.forEach((t, idx) => {
          if (intersect(t.tollSystems, tollSystemsIndexs).length > 0) {
            tollSystemsIndexs = [...tollSystemsIndexs, ...t.tollSystems];
            indexs = [...indexs, idx];
          }
        })
        tollSystemsIndexs = [...new Set(tollSystemsIndexs)];
        indexs = [...new Set(indexs)];
        // need to do twice to ensure that all tollSystems are included
        tolls.forEach((t, idx) => {
          if (intersect(t.tollSystems, tollSystemsIndexs).length > 0) {
            tollSystemsIndexs = [...tollSystemsIndexs, ...t.tollSystems];
            indexs = [...indexs, idx];
          }
        })
        tollSystemsIndexs = [...new Set(tollSystemsIndexs)];
        indexs = [...new Set(indexs)];

        spans.forEach((span, id) => {
          if (span.tollSystems) {
            if (intersect(span.tollSystems, tollSystemsIndexs).length > 0) {
              const maneuver = maneuvers.sections.find(maneuver => maneuver.id === sectionIndex);
              
              shapes.push(maneuver.spans[id].shape);
            }
          }
        })

      }
      
      setResultState({ [key]: { toll, index: indexs, sectionIndex, shapes } });
    }
  };

  render() {
    const {
      options: { key, formatter },
      result,
      refClient: { formatterPlugin },
    } = this.props;
    const maneuversFormatter = formatterPlugin.get(formatter);

    const currentRoute = get(result, 'state.currentRoute') || 0;
    const route = get(result, ['raw', 'data', 'routes', currentRoute], { sections: []});
    const maneuvers = maneuversFormatter(route);
    const selected = get(result.state, key, {});

    const sectionTolls = route.sections.map((section, sectionIndex) => {
      const { tolls, tollSystems, spans, summary = {} } = section;
      if (!tolls && !summary.tolls) return null;
      const tollArray = summary.tolls ? [...(tolls||[]), summary.tolls] : tolls;
      return <ExpandFormRow key={sectionIndex} label={`Section ${sectionIndex + 1}`} isExpanded>
        {tollArray.map((toll, index) => {
          if (index === (tolls||[]).length)
            return this.getSummaryElement({ summary, index, sectionIndex, tollSystems });
          else
            return this.getTollElement({ tolls, toll, index, sectionIndex, maneuvers, spans }, selected)
        }
        )}
      </ExpandFormRow>
    }).filter(sectionElement => sectionElement !== null);

    if (sectionTolls.length === 0) {
      return (
        <div className="rf-tollsystems-empty">
          No results <br />
        </div>
      );
    }
    return sectionTolls;
  }
}

Tolls.propTypes = {
  result: PropTypes.object,
  options: PropTypes.object.isRequired,
  setResultState: PropTypes.func.isRequired,
  refClient: PropTypes.object.isRequired,
};

export default Tolls;
